import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { reduxForm, change as changeFormData } from 'redux-form'
import { Grid, Segment } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { translate as translateHelper } from 'loankeeper-common/helpers'
import { accEntryDelete } from 'src/store/accEntry'
import { LocalLoader, withConstantPermissions, withUserConfig, withSystemConfig } from 'shared'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
import translate from '../../translator'
import { constants as DCConstants, actions as DCActions } from '../../../DetailsContainer'

import CheckboxFilters from './CheckboxFilters'
import DateFilters from './DateFilters'
import DeleteReasonModal, { constants as deleteReasonModalConstants } from '../../../shared/Modals/DeleteReasonModal'

import { EntriesProps, EntryData } from '../../types.LoanDetails'
import { Dispatch } from 'redux'

const FORM_NAME = 'loan-entries-details'
export const translateBase = (key: string): string => translateHelper(`LKMESSAGE-${key}`)

const getLKGridConfig = () => ({
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_entries',
  },

  syncGridState: true,
  enableColumnsHide: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableSorting: true,
  enableRowSelection: true,

  columnConfigs: {
    DocDate: {
      comparator: (a: moment.MomentInput, b: moment.MomentInput) =>
        LKDate.compareSameFormat(a, b, 'YYYY-MM-DD HH:mm:ss'),
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    Amount: {
      valueFormatter: ({ value }: { value: number }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    AmountEQ: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },
  },
})

const MemoizedLKGrid = ({ rowData, getContextMenuItems, onRowDoubleClicked, instanceName, redirectOnEntry }) => {
  const config = React.useMemo(() => getLKGridConfig(), [])

  return (
    <LKGrid
      instanceName={instanceName}
      rowData={rowData}
      {...config}
      getContextMenuItems={getContextMenuItems}
      onRowDoubleClicked={onRowDoubleClicked}
    />
  )
}

@withRouter
@withLivedata(['OpenDayStatus.Open_Day_Str as openDay', 'OpenDayStatus.Open_Day as openDayDate'])
@withSystemConfig('EntryDelReasonRequireMask')
@withUserConfig('ID as UserID')
//@ts-ignore
@withConstantPermissions()
//@ts-ignore
@connect(
  (state, { openDay }: { openDay: string }) => ({ initialValues: { StartDate: openDay, EndDate: openDay } }),
  //@ts-ignore
  (dispatch, { openDayDate }) => ({
    setDateFiltersToOperDay: () => {
      const formated = moment(openDayDate).format('DD.MM.YYYY')

      dispatch(changeFormData(FORM_NAME, 'StartDate', formated))
      dispatch(changeFormData(FORM_NAME, 'EndDate', formated))
    },
    accEntryDelete: (params: {
      DelReasonID: number
      OID: number
      HashSum_OID_: string
      OperTypeID: number
      Comment: string
      //@ts-ignore
    }) => dispatch(accEntryDelete(params)),
    showDeleteError: (errorMessage: string) => dispatch(LKModalActions.openInfo(translateBase(errorMessage))),
    deleteWithReason: (OID: number, HashSum_OID_: string, OperTypeID: string, onDelete: () => void) =>
      dispatch(
        LKModalActions.open({
          name: deleteReasonModalConstants.FORM_NAME,
          OID,
          HashSum_OID_,
          OperTypeID,
          onDelete,
        }),
      ),
  }),
)
//@ts-ignore
@reduxForm({
  form: FORM_NAME, // need to generate unique name
  destroyOnUnmount: false,
  onSubmit: (
    data: { StartDate: string; EndDate: string },
    dispatch: Dispatch<any>,
    { ID, hash }: { ID: string; hash: string },
  ) => {
    dispatch(DCActions.fetchPage({ type: 'Loan', ID, hash, page: 'entries', additionalParams: data }))
  },
})
class Entries extends React.Component<EntriesProps> {
  dateFilter: any

  redirectOnEntry = ({
    OperTypeID,
    ID,
    HashSum_EntryID_,
    OID,
    HashSum_OID_,
  }: {
    OperTypeID: number
    ID: number
    HashSum_EntryID_: string
    OID: number
    HashSum_OID_: string
    SEC_UserID?: any
  }) => {
    let route = `/secure/order/${ID}/details/${HashSum_EntryID_}/${OperTypeID}`

    if (OperTypeID === 6 || OperTypeID === 7) {
      route += `/${OID}/${HashSum_OID_}`
    }

    this.props.history.push(route)
  }

  onDelete = () => {
    this.props.handleSubmit()
    // this.dateFilter.reloadPage() // Grid Refresh
  }

  onRowDoubleClickedEntries = ({ node: { data } }: { node: { data: EntryData } }) => {
    const { permissions } = this.props
    if (permissions.ACC_ENTRIES_VIEW) {
      this.redirectOnEntry(data)
    }
  }

  getContextMenuItems = (params: { node: { data: EntryData } }) => {
    const {
      node: {
        data: { ID, SEC_UserID, HashSum_EntryID_, OperTypeID, OID, HashSum_OID_ },
      },
    } = params
    const { permissions, UserID, showDeleteError, deleteWithReason } = this.props

    return [
      permissions.ACC_ENTRIES_VIEW
        ? {
            name: translate('cmd_entry_details'),
            action: () => this.redirectOnEntry({ ID, SEC_UserID, HashSum_EntryID_, OperTypeID, OID, HashSum_OID_ }),
            icon: 'info',
          }
        : undefined,
      (permissions.ACC_ENTRIES_DELETE_ALIEN && UserID !== SEC_UserID) ||
      (permissions.ACC_ENTRIES_DELETE && UserID === SEC_UserID)
        ? {
            name: translate('cmd_delete'),
            action: () => {
              const { EntryDelReasonRequireMask: mask } = this.props

              if (
                (OperTypeID === 1 && mask.substr(0, 1) === '1') ||
                (OperTypeID === 3 && mask.substr(2, 1) === '1') ||
                (OperTypeID === 4 && mask.substr(3, 1) === '1') ||
                (OperTypeID === 5 && mask.substr(4, 1) === '1') ||
                (OperTypeID === 6 && mask.substr(5, 1) === '1') ||
                (OperTypeID === 7 && mask.substr(6, 1) === '1')
              ) {
                deleteWithReason(OID, HashSum_OID_, OperTypeID, this.onDelete)
              } else {
                new Promise(async (resolve, reject) => {
                  const accResult = await this.props.accEntryDelete({
                    DelReasonID: 1,
                    OID,
                    HashSum_OID_,
                    OperTypeID,
                    Comment: '',
                  })
                  const payload = accResult.payload

                  if (accEntryDelete.fulfilled.match(accResult)) {
                    resolve(payload)
                  } else {
                    reject(payload)
                  }
                })
                  .then(this.onDelete)
                  .catch((error) => showDeleteError(error))
              }
            },
            icon: 'delete',
            confirmModalConfig: { message: translateBase('MSG_ARE_YOU_SURE') },
          }
        : undefined,
      'excelExport',
    ].filter((x) => x !== undefined)
  }

  render() {
    const {
      ID,
      hash,

      data,
      loading,

      handleSubmit,
      setDateFiltersToOperDay,
      change,
    } = this.props

    return [
      <DeleteReasonModal />,
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <LocalLoader logoLoader loading={loading}>
                <MemoizedLKGrid
                  instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Entries`}
                  rowData={data}
                  redirectOnEntry={this.redirectOnEntry}
                  getContextMenuItems={this.getContextMenuItems}
                  onRowDoubleClicked={this.onRowDoubleClickedEntries}
                />
              </LocalLoader>
            </TableContainer>
          </FlexTableChild>

          <Segment>
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <Grid>
                  <Grid.Row stretched>
                    <Grid.Column width={9}>
                      <CheckboxFilters />
                    </Grid.Column>

                    <Grid.Column width={7}>
                      <DateFilters
                        ref={(instance) => {
                          this.dateFilter = instance
                        }}
                        setDateFiltersToOperDay={setDateFiltersToOperDay}
                        loading={loading}
                        ID={ID}
                        hash={hash}
                        handleSubmit={handleSubmit}
                        data={data}
                        change={change}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </form>
          </Segment>
        </Segment.Group>
      </SegmentGroup>,
    ]
  }
}

export default Entries
